module.exports = __webpack_public_path__ + "media/bgm_110.d723a1f3.m4a";